import { Link } from 'react-router-dom';

import FreeRMVControl from 'components/freeRMVControl/FreeRMVControl';
import MenuWalletButton from 'components/menu/menuWalletButton/MenuWalletButton';
import SocialsBar from 'components/socials/SocialsBar';

import RealityLogo from 'assets/logos/rda_logo.png';

import styles from './Header.module.scss';
import HeaderNavigation from './HeaderNavigation';

const SOCIAL_ORDER = [
  { type: 'medium' as const },
  { type: 'discord' as const },
  { type: 'twitter' as const },
  { type: 'telegramChat' as const },
  { type: 'telegram' as const },
  { type: 'polygonscan' as const },
  { type: 'coinmarketcap' as const },
];

interface HeaderDesktopProps {
  mapPageDisabled: boolean;
  mapUrl: string;
  onMapDisabledClick: () => void;
  variant?: 'default' | 'referral';
}

const HeaderDesktop = ({ mapPageDisabled, mapUrl, onMapDisabledClick, variant = 'default' }: HeaderDesktopProps) => {
  return (
    <div className={`${styles['menu__desktop']} ${styles[`menu__desktop--${variant}`]}`}>
      {/* Left: Logo + Navigation */}
      <div className="tw-flex tw-items-center tw-gap-7">
        <div className={styles['menu__logo']}>
          <Link to="/" aria-label="Landing page">
            <span className="avatar">
              <img src={RealityLogo} alt="RealityDA" />
            </span>
          </Link>
        </div>

        <nav className={styles['nav']} aria-label="Main navigation">
          <ul className={styles['nav-list']}>
            <HeaderNavigation
              mapPageDisabled={mapPageDisabled}
              mapUrl={mapUrl}
              onMapDisabledClick={onMapDisabledClick}
              variant={variant}
            />
          </ul>
        </nav>
      </div>

      {/* Right: Social + Controls */}
      <div className="tw-flex tw-items-center tw-gap-5">
        <SocialsBar
          order={SOCIAL_ORDER}
          className={styles['nav-bar_social__list']}
          iconClassName={styles['nav-bar__social___icon']}
        />
        <div className="tw-flex tw-items-center tw-justify-center tw-gap-[1.25rem]">
          <FreeRMVControl variant={variant} />
          <MenuWalletButton variant={variant} />
        </div>
      </div>
    </div>
  );
};

export default HeaderDesktop;
